var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Field from "./Field";
import { classNames } from "../../Util";
import Button from "../../Button";
export var disabledFieldStyle = "disabled:cursor-not-allowed disabled:border-gray-200 disabled:bg-gray-50 disabled:text-gray-500";
var InputField = function (_a) {
    var id = _a.id, displayName = _a.displayName, type = _a.type, placeholder = _a.placeholder, defaultValue = _a.defaultValue, _b = _a.disabled, disabled = _b === void 0 ? false : _b, error = _a.error, tip = _a.tip, reactHookForm = _a.reactHookForm, after = _a.after, addOn = _a.addOn, textareaHeight = _a.textareaHeight, trailingButton = _a.trailingButton, hideLabel = _a.hideLabel, _c = _a.alignRight, alignRight = _c === void 0 ? false : _c;
    var inputElProps = {
        id: id,
        name: displayName,
        placeholder: placeholder,
        defaultValue: defaultValue,
        disabled: disabled,
        className: classNames("z-10", disabledFieldStyle, error ?
            "block w-full rounded-md border-red-500 pr-10 text-red-900 placeholder-red-500 focus:border-red-500 focus:outline-none focus:ring-red-500 sm:text-sm"
            : "block w-full rounded-md border-gray-300 focus:border-blue-500 focus:ring-blue-500 sm:text-sm", addOn || trailingButton ? "rounded-none" : "", addOn ? "" : "rounded-l-md", trailingButton ? "" : "rounded-r-md", type === "textarea" && textareaHeight !== undefined ? textareaHeight : "", alignRight ? "text-right" : "")
    };
    var inputEl = (type === "textarea"
        ? _jsx("textarea", __assign({}, inputElProps, reactHookForm))
        : _jsx("input", __assign({ type: type }, inputElProps, reactHookForm)));
    return (_jsx(Field, { inputEl: _jsxs("div", __assign({ className: "flex" }, { children: [addOn &&
                    _jsx("span", __assign({ className: classNames("inline-flex items-center rounded-l-md border border-r-0 border-gray-300 bg-gray-50 px-3 text-sm text-gray-500 z-0", disabled ? "cursor-not-allowed border-gray-200 bg-gray-50 text-gray-500" : "") }, { children: addOn })), inputEl, trailingButton &&
                    _jsx(Button, __assign({}, trailingButton, { disabled: disabled, className: classNames(trailingButton.className ? trailingButton.className : "", "rounded-none inline-flex items-center rounded-r-md border border-l-0 px-3 z-0 focus:z-10 whitespace-nowrap focus:ring-offset-0", disabledFieldStyle) }))] })), id: id, displayName: displayName, tip: tip, after: after, error: error, hideLabel: hideLabel, withExclamationIcon: false }));
};
export default InputField;
